module.exports = __webpack_public_path__ + "static/media/hands-holding-circle-global-network-connection-omni-channel-multi-67627676.c21f2324.jpeg";